import { gql } from '@apollo/client';
import { apolloClient } from '../config/apollo-client';

// GraphQL query for fetching all providers
export const GET_PROVIDERS_BALANCE_QUERY = gql`
  query {
  getProviderBalance  
  {
    ... on AllProviderBalancesResponse {
      balances {
        providerName
        balance
        success
        message
      }
      success
      message
    }
    ... on ProviderBalanceResponse {
      providerName
      balance
      success
      message
    }
  }
}
`;


// GetAllProviders service class
export class GetAllProvidersBalanceService {
    private static instance: GetAllProvidersBalanceService;

  private constructor() {}

  public static getInstance(): GetAllProvidersBalanceService {
    if (!GetAllProvidersBalanceService.instance) {
      GetAllProvidersBalanceService.instance = new GetAllProvidersBalanceService();
    }
    return GetAllProvidersBalanceService.instance;
  }

    // Fetch all providers
    async getAllProvidersBalance(): Promise<any> {
        try {
            const { data } = await apolloClient.query({
                query: GET_PROVIDERS_BALANCE_QUERY,
                fetchPolicy: 'network-only',
            });
            return data.getProviderBalance;
        } catch (error: any) {
            console.error('Error fetching providers:', error);
            if (error.graphQLErrors) {
                error.graphQLErrors.forEach((err: any) => {
                    console.error('GraphQL Error:', err.message);
                    console.error('Locations:', err.locations);
                    console.error('Path:', err.path);
                });
            }
            if (error.networkError) {
                console.error('Network Error:', error.networkError);
            }
            throw error;
        }
    }
}

// Export singleton instance
export const getAllProvidersBalanceService = GetAllProvidersBalanceService.getInstance();

// Export convenience function
export async function getAllProvidersBalance(): Promise<any> {
    return getAllProvidersBalanceService.getAllProvidersBalance();
}
